<template>
    <div class="onboarding-question">
        <a class='scroll-point'></a>
        <p class="page-number">{{ pageNumber }}/{{ numQuestions }}</p>
        <h1 class="onboarding-heading">{{ heading }}</h1>

        <div class="onboarding-question-cards-wrapper" key="selected" ref="cardWrapper">
            <div v-for="(parentOption, i) in parentOptions" class="onboarding-question-card" @click="onParentAnswered(parentOption, i)" ref="questionCard">
                <img class="onboarding-question-card-img" :src="require('coffee-preferences/' + parentOption.image_name)" alt="Onboarding Question">
                <p class="option-name">{{ parentOption.name }}</p>
            </div>
        </div>
        <div  v-if="!parentOptionSelected" class="onboarding-question-tip">
            <img class="question-tip-icon" :src="require('home/onboarding/light-bulb-icon.png')" alt="Onboarding Question">
            {{ tip }}
        </div>

        <transition name="fade" mode="out-in">
            <CoffeeQuiz
                    v-show="parentOptionSelected"
                    :page-number="6"
                    :num-questions="numQuestions"
                    :heading="'Flavor Nuances'"
                    :options="displayedChildOptions"
                    :tip="'Coffee is one of the most complicated beverages in the world. This helps us really dial in what you might enjoy most.'"
                    :hide-name="true"
                    v-on:answered="onChildAnswered"
                    v-on:deselected="onChildDeselected"
                    ref="childQuestion"
            />
        </transition>
    </div>
</template>

<script>
    import CoffeeQuiz from './coffee-quiz-question'
    import AnimationMixin from '../../../mixins/animation';

    export default {
        components: {
            CoffeeQuiz
        },
        props: {
            pageNumber: undefined,
            heading: String,
            parentOptions: Array,
            childOptions: Array,
            numQuestions: Number,
            tip: String
        },
        mixins: [
            AnimationMixin
        ],
        data: function() {
            return  {
                parentOptionSelected: undefined,
                childSelected: undefined,
                animationTimeLine: undefined
            }
        },
        methods: {
            onParentAnswered(option, index) {
                if (this.parentOptionSelected) {
                    this.onParentDeselected();
                    return;
                }

                this.animationTimeLine = this.createTimeLineForOnboardingQuiz(this.$refs.questionCard, this.$refs.cardWrapper, index);
                this.animationTimeLine.play();
                this.parentOptionSelected = option;
                this.$emit('answered', option);
            },
            onChildAnswered(option) {
                if (this.childSelected) {
                    return;
                }

                this.childSelected = option;
                this.$emit('answered', option);
            },
            onParentDeselected() {
                if (!this.parentOptionSelected) {
                    return;
                }

                this.animationTimeLine.reverse();
                this.$emit('deselected', this.parentOptionSelected);
                this.parentOptionSelected = undefined;

                if (this.childSelected) {
                    this.$emit('deselected', this.childSelected);
                    this.childSelected = undefined;
                    this.$refs.childQuestion.optionSelected = undefined;
                }
            },
            onChildDeselected() {
                if (!this.childSelected) {
                    return;
                }

                this.$emit('deselected', this.childSelected);
                this.childSelected = undefined;
            }
        },
        computed: {
            displayedChildOptions: function () {
                if (!this.parentOptionSelected) {
                    return null;
                }
                return this.childOptions.filter(o => o.parent_option === this.parentOptionSelected.key);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/variables_home";
    @import "../../../styles/common_home";

    .onboarding-question {
        max-width: 1000px;
        margin: auto;
        padding-top: 5rem;
        text-align: center;
        position: relative;
    }
    .scroll-point {
        position: absolute;
        top: -250px;
    }
    .page-number {
        margin-bottom: 0;
    }
    .onboarding-heading {
        margin: 0 2rem .5rem 2rem;
        letter-spacing: -1px;
    }
    .onboarding-sub-heading {
    }
    .onboarding-question-cards-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .onboarding-question-card {
        box-sizing: border-box;
        width: 20vw;
        height: 20vw;
        max-width: 220px;
        max-height: 220px;
        min-width: 160px;
        min-height: 160px;
        margin-top: 2rem;
        margin-bottom: 1rem;
        cursor: pointer;
        transition: 1s;
        &:hover {
            font-weight: bold;
        }
    }
    .onboarding-question-card-img {
        width: 80%;
        height: 80%;
        margin-bottom: .5rem;
    }
    .option-name {
        margin: 0;
    }
    .onboarding-question-tip {
        width: 400px;
        margin: 4rem auto;
        padding: 2rem;
        border: 1px solid $color-primary;
        border-radius: 11px;
        position: relative;

    }
    .question-tip-icon {
        width: 30px;
        height: 30px;
        position: absolute;
        top: -15px;
        left: 211px;
    }
    @media only screen and (max-width: $max-tablet-width) {
        .onboarding-question {
            padding-top: 112px;
            padding-top: 2rem;
        }
        .scroll-point {
            top: -150px;
        }
        .onboarding-heading {
            margin-bottom: 1rem;
        }
        .onboarding-question-tip {
            width: 240px;
            margin-top: 2rem;
            padding: 1.5rem;
        }
        .question-tip-icon {
            position: absolute;
            top: -15px;
            left: 125px;
        }
    }
</style>
